import React, { Component, Fragment } from 'react'
import styles from './school-overview.styles'
import injectSheet from 'react-jss'
import { Route } from 'react-router-dom'
import SchoolHead from '../../school-head/school-head'
import Pupils from '../pupils/pupils.container'
import Groups from '../groups/groups.container'

class SchoolOverview extends Component {
  render() {
    return (
      <Fragment>
        <SchoolHead />
        <Route exact path="/" component={Pupils} />
        <Route exact path="/groups" component={Groups} />
      </Fragment>
    )
  }
}

export default injectSheet(styles)(SchoolOverview)
